import api from './data.services'
import { authService } from '.'

const familyMemberSrv = 'requests/families/member'

const getNewIntegrand = async (id: number) => {
  try {
    const resp: any = await api.get(`${familyMemberSrv}/${id}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp.data ? resp.data : [])
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al obtener familiar')
    }
  }
}

export const familyMemberService = {
  getNewIntegrand
}